// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__I9ObH","image":"Header_image__3UKQQ","name":"Header_name__1wW3u","info":"Header_info__177LU","infoRow":"Header_infoRow__SyUiJ"};